import { Popup } from 'antd-mobile';
import { useState, useRef, useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { copyText, isLogin, checkPined } from '@/utils/index';
import './index.less';
import logo from '@/assets/images/logo_title.png';
import caidan from '@/assets/images/home/menu_ico.png';
import faceBook from '@/assets/images/poster/facebook_cai.png';
import tg from '@/assets/images/poster/telegram_cai.png';
import whatsapp from '@/assets/images/poster/whatsapp.png';
import ins from '@/assets/images/poster/insgram_cai.png';
import twitter from '@/assets/images/poster/twitter_cai.png';
import pg from '@/assets/images/poster/gg_pg.png';
import quente from '@/assets/images/poster/gg_quente.png';
import slot from '@/assets/images/poster/gg_slot.png';
import pp from '@/assets/images/poster/gg_pp.png';
import blockChain from '@/assets/images/poster/gg_blockchain.png';
import lazer from '@/assets/images/poster/gg_lazer.png';
import sanjiao_bai from '@/assets/images/sanjiao_bai.png';
import level1 from '@/assets/images/level_1_1.png';
import { ToLoginOrRegister } from '@/components/popup/ToLoginOrRegister';
import { getMoney } from '@/api';
import { formatter } from '@/utils/mathWays';
import { useActiveConfigList } from '@/store';
import { useCommonVisible } from '@/hooks';
import { categoryMap } from './Main.tsx';
import { useActivate, useUnactivate } from 'react-activation';
import { getS3Url } from '@/utils';
import { Toast } from 'antd-mobile';
import { gotoActivity } from '@/utils';
// import { IOS } from '@/utils/client.ts';

const Header = ({ appConfig, gameCategorys }) => {
  const [visible, setVisible] = useState(false);
  const [totalMoney, setTotalMoney] = useState(0);
  const userRef = useRef<HTMLDivElement>(null);
  const topUserRef = useRef<HTMLDivElement>(null);
  // const language = localStorage.getItem('language');
  const [searchParams] = useSearchParams();
  const queryParams = searchParams.toString();
  // const gp = searchParams.get('gp') || '';
  const loginPopup = useCommonVisible();
  // const updateIsRain = useIsRain(state => state.updateIsRain);
  const timerRef = useRef<any>(null);

  const allConfigList = useActiveConfigList(state => state?.allConfigList);

  // 代理中心开启才能显示入口
  const isShowAgentCenter = useMemo(
    () =>
      allConfigList?.find(
        item => item?.activityType === 'AGENT_REWARD' && item?.status === 0
      ),
    [allConfigList]
  );
  const defaultValue = {
    mainGameList: [
      { id: 1, imgUrl: pg },
      { id: 2, imgUrl: quente },
      { id: 3, imgUrl: slot },
      { id: 4, imgUrl: pp },
      { id: 5, imgUrl: blockChain },
      { id: 6, imgUrl: lazer }
    ],
    mediaList: [
      {
        imgUrl: faceBook,
        goUrl: 'https://www.facebook.com/profile.php?id=61559119506790'
      },
      {
        imgUrl: tg,
        goUrl: 'https://t.me/jogo9000'
      },
      {
        imgUrl: whatsapp,
        goUrl: 'https://www.whatsapp.com/channel/0029VaejutjEwEjrZ74old3Q'
      },

      {
        imgUrl: ins,
        goUrl: 'https://www.instagram.com/baxi9000com/'
      },
      {
        imgUrl: twitter,
        goUrl: ' https://twitter.com/baxi9000com/'
      }
    ]
  };

  const jumpMedia = val => {
    if (!val.goUrl) {
      return;
    }
    window.open(val.goUrl);
  };

  const queryMoney = async () => {
    const res = await getMoney();
    if (res.code === 200) {
      setTotalMoney(res.data?.amount || 0);
    } else {
      setTotalMoney(0);
    }
  };

  const downloadConfig =
    JSON.stringify(appConfig) != '{}' ? appConfig : defaultValue;
  const navigate = useNavigate();
  // const location = useLocation();

  const [user, setUser] = useState<any>({});
  // console.log('🚀 ~ user:', user);

  const [isPopupOpen, setIsPopupOpen] = useState(false); // 弹窗显示状态
  const getUserInfo = () => {
    const userInfo = localStorage.getItem('userInfo');
    return userInfo ? JSON.parse(userInfo) : null;
  };
  // 判断用户是否已登录
  const checkLoggedIn = () => {
    const userInfo = getUserInfo();
    if (userInfo) {
      setUser(userInfo);
    }
  };

  useEffect(() => {
    checkLoggedIn();
    if (isLogin()) {
      queryMoney();
    }
  }, [isLogin]);

  useActivate(() => {
    if (isLogin()) {
      queryMoney();
    }
  });
  useActivate(() => {
    timerRef.current = setInterval(() => {
      if (isLogin()) {
        queryMoney();
      } else {
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
        }
      }
    }, 3000);
  });
  useUnactivate(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  });

  useEffect(() => {
    timerRef.current = setInterval(() => {
      if (isLogin()) queryMoney();
    }, 3000);
    if (!isLogin()) {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    }
    return () => {
      // closeIsOpenStatus();
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  const goLink = name => {
    if (isLogin()) {
      navigate(`/${name}?${searchParams}`);
    } else {
      setVisible(false);
      loginPopup.open();
    }
  };

  const togglePopup = () => {
    checkLoggedIn();
    setIsPopupOpen(!isPopupOpen);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        userRef.current &&
        !userRef.current.contains(event.target) &&
        topUserRef.current &&
        !topUserRef.current.contains(event.target)
      ) {
        setIsPopupOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    return checkPined(document.querySelector('#brand') as HTMLInputElement,
      el => {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve(el.getBoundingClientRect().top <= 1);
          }, 20);
        });
      },
      5
    );
  }, []);

  // const [showTip, setTip] = useState(false);
  const showTip = () => {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    const urlParams = new URLSearchParams(location.search.split('?')[1]);

    const isInPWA = () => {
      const displayModes = ['fullscreen', 'standalone', 'minimal-ui'];
      return displayModes.some(
        mode => window.matchMedia(`(display-mode: ${mode})`).matches
      ) && !isIOS
    };
    // 检测是否添加到iOS桌面
    const isFromIOSScreen = () => {
      // @ts-ignore
      return window.navigator.standalone && isIOS;
    };

      // @ts-ignore
    const isInIosApp = isIOS && (window.webkit && window.webkit.messageHandlers);
      // @ts-ignore
    const isInAndroidApp = isAndroid && (urlParams.get('platform') == 'android' || urlParams.get('type') == '1') // android webview
    const isInApp = () => {
      return isInIosApp || isInAndroidApp;
    };

    const tip = `isInPWA=${isInPWA()}, isFromIOSScreen=${isFromIOSScreen()}, isInAndroidApp=${isInAndroidApp}, isInIosApp=${isInIosApp}, isInApp=${isInApp()}`;
    const userId = getUserInfo()?.userId;
    // const userId = 10025230
    if (userId == '10025230') {
      Toast.show({
        // icon: 'success',
        content: tip,
        duration: 10000
      });
    }
  }

  useEffect(() => {
    showTip()
  }, [])

  useActivate(() => {
    showTip()
  })

  return (
    <div className="app-name h-14" id="brand">
      <>
        <div className="absolute left-0 top-[8px] flex items-center pl-[16px] pt-[3px]">
          <div
            onClick={() => {
              setVisible(true);
            }}
          >
            <img className='w-[22px] h-[22px]' src={caidan} />
          </div>
          <div className="bg-clip-text scale-x-[0.9] scale-y-[1.2]">
            <img
              src={getS3Url('home/logo_title.png')}
              className="w-[150px] h-[28px]"
            />
          </div>
        </div>
        {isLogin() ? (
          <>
            <div className="app-user-frame">
              <div className="app-user-box" ref={userRef} onClick={togglePopup}>
                <img
                  src={getS3Url('home/i_meiyuan.png')}
                  className="icon-nofree"
                />
                <span className="value-text">
                  {formatter.format(totalMoney)}
                </span>
                <div className="value-line"></div>
                <img
                  src={sanjiao_bai}
                  className={
                    isPopupOpen ? 'value-arrow' : 'value-arrow up-arrow'
                  }
                />
              </div>
            </div>
          </>
        ) : (
          <div className="brandBtns">
            <div
              className="login-button"
              onClick={() =>
                navigate(queryParams ? `/login/1?${queryParams}` : '/login/1')
              }
            >
              Entrar
            </div>
            <div
              className="register-button"
              onClick={() =>
                navigate(queryParams ? `/login/2?${queryParams}` : '/login/2')
              }
            >
              Registro
            </div>
          </div>
        )}

        {isPopupOpen && isLogin() && (
          <div className="top-user-panel" ref={topUserRef}>
            <div className="top-user-panel-arrow"></div>
            <div className="top-user-panel-body">
              <div
                className="top-user-info"
                onClick={() => navigate('/profile')}
              >
                <div className="top-user-img">
                  <img
                    src={`./images/${user.avatar ? user.avatar : './02.png'}`}
                    className="uImg"
                  />
                </div>
                <div className="top-user-name">
                  <span className="ml-[10px]">{user.username}</span>
                </div>
              </div>
              <div className="top-user-center flex justify-start items-center">
                <div className="top-user-uid">
                  <span className="idspan ml-[10px]">ID:</span>
                  <span>{user.userId}</span>
                </div>
                <div
                  className="user-copy"
                  onClick={() => copyText(user.userId)}
                >
                  <img
                    src={getS3Url('home/i1.png')}
                    className="top-user-panel-copyimg"
                  />
                </div>
              </div>
              <div className="top-user-panel-coin flex justify-between items-center rounded mt-2 h-10">
                <div className="top-user-coinL flex justify-between items-center">
                  <img
                    src={getS3Url('home/i_meiyuan.png')}
                    className="top-user-panel-coinimg w-5 ml-3"
                  />
                  <span className="top-user-panel-cointext1 pl-1">Saldo</span>
                </div>

                <span className="top-user-panel-cointext3 mr-3">
                  {formatter.format(totalMoney)}
                </span>
              </div>
              <div className="top-user-panel-level flex justify-start items-center h-10 mt-2">
                <img
                  src={level1}
                  className="top-user-panel-levelimg w-[33px]"
                />
                <div className="top-user-panel-level-line bg-white ml-3"></div>
                <img
                  src={getS3Url('home/i5.png')}
                  className="top-user-panel-vipicon w-[42px] ml-2"
                />
                <div className="top-user-panel-viptext">0</div>
              </div>
            </div>
          </div>
        )}

        <Popup
          visible={visible}
          onMaskClick={() => {
            setVisible(false);
          }}
          position="left"
          className="z-[10]"
          bodyClassName="text-[#ababae] "
          maskClassName="popupFrameMask"
          getContainer={() => {
            return document.getElementById('topBar') as HTMLElement;
          }}
        >
          {visible && (
            <div className="popupFrame w-[266px] h-screen text-textSecondary">
              <div className="ltop-frame flex items-center">
                <img
                  className="w-[22px] h-[22px] ml-[12px] mr-[12px]"
                  src={caidan}
                  onClick={() => setVisible(!visible)}
                />
                <div className="g-clip-text mt-[-2px]">
                  <img src={getS3Url('home/logo_title.png')} alt="" width={120} />
                </div>
              </div>

              <div
                className="main-left-content pb-30"
                style={{ overflowY: 'scroll' }}
              >
                <div className="b-content">
                  <div className="quickBtns mb-3 h-[36px]">
                    <div
                      className="deposito w-[150px]"
                      onClick={() => goLink('deposito')}
                    ></div>
                    <div
                      className="saque w-[90px]"
                      onClick={() => navigate('/chooseSaque')}
                    >
                      Saque
                    </div>
                  </div>

                  {/* 游戏厅室 */}
                  <ContentTab>
                    <div className="lrecord-item">
                      <div className="gmenu-item">
                        <img
                          src={getS3Url('home/i3.png')}
                          className="gmenu-item-img"
                        />
                        <span className="rtext-normal">Casa de Jogos</span>
                        <span className="toggle"></span>
                      </div>
                    </div>
                    <div className="lcontent-frame">
                      {gameCategorys.map((item, index) => {
                        return (
                          (item.showType === 1 || item.showType === 3) && (
                            <div
                              className="lgroup-item-frame w-[30%] overflow-hidden"
                              key={index}
                              onClick={() => {
                                if (item.type === 'Custom') {
                                  const categoryId = item.categoryId;
                                  const customCategory = gameCategorys.find(
                                    item =>
                                      String(item.id) === String(categoryId)
                                  );
                                  navigate('/game_category', {
                                    replace: false,
                                    state: {
                                      isCustom: true,
                                      customDisplay: item.display,
                                      currentCategory: customCategory,
                                      currentRoom: item.roomList[0],
                                      icon: item.customIcon || item.icon
                                    }
                                  });
                                } else {
                                  navigate('/game_category', {
                                    replace: false,
                                    state: {
                                      currentCategory: item
                                    }
                                  });
                                }
                              }}
                            >
                              <div className="lgroup-item-content flex flex-col">
                                <img
                                  src={
                                    item.customIcon ||
                                    item.icon ||
                                    categoryMap[item.code]
                                  }
                                  className="w-8 h-8 object-cover"
                                />
                                <div className="text-[white] text-center leading-4 mt-1 whitespace-nowrap overflow-x-hidden text-clip">
                                  {item.display || item.code || item.name}
                                </div>
                              </div>
                            </div>
                          )
                        );
                      })}
                    </div>
                  </ContentTab>
                  {/* 活动区域 */}
                  <ContentTab>
                    <div className="lrecord-item">
                      <div className="gmenu-item">
                        {/* <img src={logGreen} className="gmenu-item-img" /> */}
                        <img
                          src={getS3Url('home/i2.png')}
                          className="gmenu-item-img"
                        />
                        <span className="rtext-normal">Promoções</span>
                        <span className="toggle"></span>
                      </div>
                    </div>
                    <div className="lcontent-frame">
                      {allConfigList.length > 0
                        ? allConfigList.map(
                            ({
                              id,
                              link,
                              activityType,
                              menuLogo,
                              showRedPoint,
                              logoName
                            }) => {
                              return (
                                <div
                                  key={id}
                                  className="lgroup-item-frame w-[30%] overflow-hidden"
                                >
                                  <div className="lgroup-item-content flex flex-col w-full text-center">
                                    <img
                                      src={menuLogo}
                                      alt={activityType}
                                      className="rounded-lg w-9 h-9 my-1"
                                      onClick={() => {
                                        gotoActivity(link, id);
                                      }}
                                    />
                                    {showRedPoint && (
                                      <i className="w-3 h-3 rounded-full bg-[#EE0A24] absolute top-2 right-2" />
                                    )}
                                    <span className="truncate leading-[1.5] h-4 w-full px-1">
                                      {logoName}
                                    </span>
                                  </div>
                                </div>
                              );
                            }
                          )
                        : null}
                    </div>
                  </ContentTab>

                  <div className="lrecord-item">
                    <div
                      className="gmenu-item"
                      onClick={() => goLink('registro')}
                    >
                      <img
                        src={getS3Url('home/i_9.png')}
                        className="gmenu-item-img"
                      />
                      <span className="rtext-normal">Meus relatórios</span>
                    </div>
                  </div>
                  <div className="lrecord-item">
                    <div
                      className="gmenu-item"
                      onClick={() => goLink('profile')}
                    >
                      <img
                        src={getS3Url('home/i_8.png')}
                        className="gmenu-item-img"
                      />
                      <span className="rtext-normal">Configuração</span>
                    </div>
                  </div>
                  {isShowAgentCenter && (
                    <div className="lrecord-item">
                      <div
                        className="gmenu-item"
                        onClick={() => goLink('agentcenter')}
                      >
                        <img
                          src={getS3Url('home/i_7.png')}
                          className="gmenu-item-img"
                        />
                        <span className="rtext-normal">Centro de Agentes</span>
                      </div>
                    </div>
                  )}

                  {/* </div> */}

                  {/* 媒体按钮 */}
                  <ContentTab>
                    <div className="lrecord-item">
                      <div className="gmenu-item">
                        {/* <img src={logGreen} className="gmenu-item-img" /> */}
                        <img
                          src={getS3Url('home/i6.png')}
                          className="gmenu-item-img"
                        />
                        <span className="rtext-normal">Canal Oficial</span>
                        <span className="toggle"></span>
                      </div>
                    </div>
                    <div className="lcontent-frame">
                      {downloadConfig.mediaList.map((item, index) => {
                        return (
                          // 移除18
                          item.mediaName != '18' && (
                            <div
                              className="lgroup-item-frame w-[30%] overflow-hidden"
                              key={index}
                              onClick={() => jumpMedia(item)}
                            >
                              <div className="lgroup-item-content flex flex-col">
                                <img
                                  src={item.imgUrl}
                                  className="w-8 h-8 object-cover"
                                />
                                <div className="text-[white] text-center leading-4 mt-1 whitespace-nowrap overflow-x-hidden text-clip">
                                  {item.mediaName}
                                </div>
                              </div>
                            </div>
                          )
                        );
                      })}
                    </div>
                  </ContentTab>
                </div>
                <div className="clear-both text-[11px] text-white flex items-center p-3">
                  <img
                    src={getS3Url('home/i_18.png')}
                    alt=""
                    className="w-[28px] h-[28px] mr-2 center"
                  />
                  Todos os direitos reservados. 18+
                </div>
              </div>
            </div>
          )}
        </Popup>

        <ToLoginOrRegister
          isOpen={loginPopup.visible}
          setIsOpen={loginPopup.close}
        />
      </>
    </div>
  );
};

function ContentTab(props) {
  const [isOpen, toggle] = useState(false);

  return (
    <>
      <div className={isOpen ? 'opened' : ''} onClick={() => toggle(!isOpen)}>
        {props.children[0]}
      </div>
      {isOpen && <div> {props.children[1]} </div>}
    </>
  );
}

export default Header;
